// extracted by mini-css-extract-plugin
module.exports = {"balance":"Balance_balance__80Zyx","currencyImage":"Balance_currencyImage__3jkqP"};